import SectionLanding from '../components/SectionLanding';

// Cards come from the Финансии entry in navConfig, so this page always offers
// exactly the options the sidebar does.
export default function InvoicePage() {
  return <SectionLanding sectionName="Финансии" />;
}
